import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import { handleRateLimit } from "utils/handleRateLimit";
import dynamic from "next/dynamic";
const StaticPage = dynamic(() => import('Features/ECOMM/StaticPages/components/StaticPage'))

const Index = ({ data }) => {
    return (
        <>
            <PageContextWrapper
                page='trade-customers'
                page_content={data.template_page_content}
            >
                <StaticPage
                    {...data}
                    sx={{
                        'p': {
                            color: '#606366',
                            'strong': {
                                color: '#606366'
                            }
                        }
                    }}
                />
            </PageContextWrapper>
        </>
    );
};

export async function getServerSideProps({ query, res }) {
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-page-data?page=trade-customers`);
        const data = await req.json()

        const rateLimitRedirect = handleRateLimit(res, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (data.exception) {
            return { notFound: true }
        }

        return {
            props: {
                data
            },
        };

    } catch (error) {
        return { notFound: true } //404
    }
}

export default Index;
